import { useCallback, useRef, useState } from 'react'

import Head from 'next/head'

import { useFoodMutationAsync } from '~/api-client/food_api'
import { BackButton } from '~/components/action/BackButton'
import { Button } from '~/components/action/Button'
import { TextArea } from '~/components/data-input/TextField'
import { NGWordModal } from '~/components/food_app/NGWordModal'
import { Container, ContainerInset } from '~/components/layout/Container'
import { Header } from '~/components/layout/Header'
import { getFormValueString } from '~/libs/form'
import { anyNgWordIncluded } from '~/libs/ng_words'

export const DictionaryDialogContentEdit: React.FC<{
  term: { id: string; text: string }
  onBack: () => void
  onUpdated: () => void
}> = (props) => {
  const formRef = useRef<HTMLFormElement>(null)
  const [ngWordsModal, setNgWordsModal] = useState(false)
  const [messageError, setMessageError] = useState<string>()
  const [submitting, setSubmitting] = useState(false)

  const updateUserDictionaryTerm = useFoodMutationAsync(
    '/user/update_user_dictionary_term'
  )

  const handleSubmit: React.FormEventHandler = useCallback(
    async (e) => {
      e.preventDefault()
      e.stopPropagation()
      if (formRef.current == null) return
      try {
        setSubmitting(true)
        const formData = new FormData(formRef.current)
        const text = getFormValueString(formData, 'text') ?? ''
        if (anyNgWordIncluded(text)) {
          setNgWordsModal(true)
          return
        }
        await updateUserDictionaryTerm({
          userDictionaryTermId: props.term.id,
          text,
        })
        props.onUpdated()
      } finally {
        setSubmitting(false)
      }
    },
    [updateUserDictionaryTerm, props]
  )

  return (
    <>
      <Head>
        <title>辞書登録</title>
      </Head>

      <NGWordModal isOpen={ngWordsModal} setIsOpen={setNgWordsModal} />

      <Header>
        <div className="w-5">
          <BackButton onClick={props.onBack} />
        </div>
        辞書登録
        <div className="w-5" />
      </Header>

      <Container>
        <ContainerInset>
          <form ref={formRef} onSubmit={handleSubmit} className="text-sm">
            <TextArea
              dynamicHeight
              textareaClassName="max-h-[70vh] min-h-[40vh]"
              error={messageError}
              inputProps={{
                name: 'text',
                defaultValue: props.term.text,
                onChange: (e) => {
                  if (e.target.value.length > 1000) {
                    setMessageError('1000文字以内で入力してください')
                  } else {
                    setMessageError(undefined)
                  }
                },
              }}
            />
            <div className="mt-5 flex justify-center">
              <Button
                type="submit"
                variant="primary"
                disabled={submitting || messageError != null}
              >
                登録する
              </Button>
            </div>
          </form>
        </ContainerInset>
      </Container>
    </>
  )
}
